import { defineStore } from 'pinia'

// @ts-expect-error: vuex
import { useStore } from 'vuex'
import { apiPermissionsFlags } from '@/helpers/getChildActions'
import type { ChildEditionId, ExclusionRequestData } from '@/types/childEdition'
import { computed, ref } from 'vue'
import childEdition from '@/services/http/api/childEdition'

export const useChildEditionStore = defineStore('childEdition', () => {
  const vuexStore = useStore()
  const { getAssignedFirst, getAssignedFlag, getIsCoordinator } = apiPermissionsFlags()

  const excludeModalVisibility = ref<boolean>(false)

  const getChildsEditionName = async (childEditionId: ChildEditionId) => {
    let editionName: string = vuexStore.getters['childEdition/getChildsEditionName']
    if (!editionName) {
      try {
        await vuexStore.dispatch('childEdition/getChild', {
          childEditionId,
          isCoordinator: getIsCoordinator,
          getAssignedFirst,
          getAssignedFlag
        })
      } catch (error) {
        return Promise.reject(error)
      }
      editionName = vuexStore.getters['childEdition/getChildsEditionName']
    }
    return editionName
  }

  const excludeChild = async (
    childEditionId: ChildEditionId,
    requestData: ExclusionRequestData
  ) => {
    vuexStore.commit('childEdition/setModalLoader', true)

    try {
      const result = await childEdition.excludeChild({
        childEditionId,
        data: requestData
      })

      const child = vuexStore.getters['childEdition/getChild']
      const { school_hydra_users: schoolHydraUsers } = child
      vuexStore.commit('childEdition/setChild', {
        child_edition: result.data.data,
        school_hydra_users: schoolHydraUsers
      })
    } catch (error) {
      return Promise.reject(error)
    } finally {
      vuexStore.commit('childEdition/setModalLoader', false)
      excludeModalVisibility.value = false
    }
  }

  const getChildGiftGiverModuleHash = computed(() => {
    const child = vuexStore.getters['childEdition/getChild']

    return child.child_edition?.gift_giver_module_hash ?? ''
  })

  return {
    excludeModalVisibility,

    getChildsEditionName,
    excludeChild,
    getChildGiftGiverModuleHash
  }
})
